const Team = require('@/tbs/model/to/Team')
const team = new Team

const tbs_model_vo_MatchTeam = function() {
}

tbs_model_vo_MatchTeam.prototype = {
    /* The view object name */
    name: 'team',
    /* The view object instance */
    view: {
        query: [
            {
                name: 'teamList',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMMatchSignupTeamList',
                query: {
                    matchId: 'matchGroupId',
                    unionMatchId: 'matchId',
                    pageSize: '(100)',
                    sortType: '(1)',
                },
                basePath: 'data.list',
                rule: {
                    id: 'id',
                    logoUrl: 'badge',
                    name: 'name',
                    memberTotal: 'playerCount',
                    entryTotal: 'times',
                    groupId: 'groupId',
                    groupName: 'groupName',
                }
            },
            {
                name: 'matchRule',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchRule',
                query: {
                    id: 'matchGroupId'
                },
                basePath: 'data.match',
                rule: {
                    teamTotal: 'roundRobinTeamCount',
                    groupTotal: '$roundRobinGroupCount,roundRobinTeamCount',
                    groupTeamTotal: '$roundRobinGroupCount,roundRobinTeamCount',
                    groupNameList: '$groupNameType'
                }
            },
            {
                name: 'roundList',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchGameRoundList',
                query: {
                    matchId: 'matchGroupId'
                },
                basePath: 'data.list',
                rule: {
                    gameCount: 'gameCount',
                    isGroupGame: '@isGroupGame',
                    round: 'round',
                    stageId: 'stageId'
                }
            },
        ],
        getGroupList: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchStageGroupList',
            query: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
                includeTeamInfo: '(false)',
            },
            basePath: 'data.list',
            rule: {
                value: 'id',
                text: 'name',
            }
        },
        getGroupTeamList: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchStageGroupList',
            query: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
            },
            basePath: 'data.list',
            rule: {
                id: 'id',
                name: 'name',
                seq: 'seq',
                teamList: 'teams'
            }
        },
        resetGroupTeamList: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchStageTeamGroupClear',
            method: 'POST',
            basePath: '',
            rule: {
                matchId: 'matchGroupId',
                stageId: 'stageId',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchTeam',
            basePath: 'data.team',
            rule: {
                id: 'id',
                matchGroupId: 'matchId',
                name: 'name',
                logoUrl: 'badge',
                homeTeamSuit: '$clothesIds',
                awayTeamSuit: '$clothesIds',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateBMTeam',
            basePath: '',
            rule: {
                matchId: 'matchGroupId',
                badge: 'logoUrl',
                name: 'name',
                clothesIds: '$homeTeamSuit,awayTeamSuit',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchTeam',
            basePath: '',
            rule: {
                id: 'id',
                matchId: 'matchGroupId',
                badge: 'logoUrl',
                name: 'name',
                clothesIds: '$homeTeamSuit,awayTeamSuit',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminDeleteBMMatchTeam',
            basePath: '',
            rule: {
                teamIds: 'id',
                matchIds: 'matchGroupId'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderGroupNameList: function(type) {
        type = type || 1
        return this.getGroupNameListByType(type)
    },
    renderGroupTeamTotal: function(roundRobinGroupCount, roundRobinTeamCount) {
        return Math.ceil(roundRobinTeamCount / roundRobinGroupCount)
    },
    renderGroupTotal: function(roundRobinGroupCount, roundRobinTeamCount) {
        if (roundRobinGroupCount != roundRobinTeamCount) {
            return roundRobinGroupCount
        }
        else {
            return 0
        }
    },
    renderHomeTeamSuit: function(clothesIds) {
        clothesIds = clothesIds || ','
        return clothesIds.split(',')[0]
    },
    renderAwayTeamSuit: function(clothesIds) {
        clothesIds = clothesIds || ','
        return clothesIds.split(',')[1]
    },
    formatClothesIds: function(homeTeamSuit, awayTeamSuit) {
        return (homeTeamSuit ? homeTeamSuit : '') + ',' + (awayTeamSuit ? awayTeamSuit : '')
    },
    statusOptions: [
        { text: team.localeProp('all-status'), value: '0' }
    ],
    getDivisionOptions: function(groupList) {
        const options = [
            { text: team.localeProp('all-divisions'), value: '0' }
        ]
        if (groupList && groupList.length > 0) {
            return options.concat(groupList.map(item => {
                return {
                    text: item.text + team.localeProp('group-unit'),
                    value: item.value
                }
            })).concat([{ text: team.localeProp('unassigned-division'), value: '1' }])
        }
        return options
    },
    getGroupNameListByType: function(type) {
        const groupNameSet = team.localeProp('group-name-set-type-' + type)
        return groupNameSet.split(',')
    }
}

module.exports = tbs_model_vo_MatchTeam